export const VIEWS = {
    primary: 'primary',
    secondary: 'secondary',
    readonly: 'readonly'
};

export const VARIANTS = {
    regular: 'regular',
    rounded: 'rounded'
};

export const COLORS = {
    lbNegative: 'lb_negative',
    lbSuccess: 'lb_success',
    lbHowToPlay: 'lb_howToPlay',
    success: 'success',
    negative: 'negative',
    info: 'info',
    revert: 'revert',
    generic: 'generic'
};

export const SIZES = {
    large: 'large',
    medium: 'medium',
    small: 'small'
};

export const STATUSES = {
    active: 'active',
    hover: 'hover'
};
